import { render, staticRenderFns } from "./EnhancedPdfViewer.vue?vue&type=template&id=2d3a3fab&scoped=true"
import script from "./EnhancedPdfViewer.vue?vue&type=script&lang=js"
export * from "./EnhancedPdfViewer.vue?vue&type=script&lang=js"
import style0 from "./EnhancedPdfViewer.vue?vue&type=style&index=0&id=2d3a3fab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3a3fab",
  null
  
)

export default component.exports